"use client";

import { Box, Flex, type BoxProps } from "@chakra-ui/react";

interface MarqueeStripProps extends BoxProps {
  items: readonly string[];
  durationSec?: number;
}

const MarqueeContent = ({ items }: { items: readonly string[] }) => (
  <Flex align="center" gap={12} px={6} flexShrink={0}>
    {items.map((item, i) => (
      <Flex key={i} as="span" align="center" gap={12}>
        <Box as="span">{item}</Box>
        <Box as="span" opacity={0.4}>
          ✦
        </Box>
      </Flex>
    ))}
  </Flex>
);

/** Infinite horizontal scroll strip — content is duplicated once so the loop is seamless. */
export const MarqueeStrip = ({
  items,
  durationSec = 32,
  ...boxProps
}: MarqueeStripProps) => (
  <Box overflow="hidden" {...boxProps}>
    <Flex
      w="max-content"
      animation={`marquee ${durationSec}s linear infinite`}
    >
      <MarqueeContent items={items} />
      <MarqueeContent items={items} />
    </Flex>
  </Box>
);
